import {
	Combobox,
	ComboboxButton,
	ComboboxInput,
	ComboboxOption,
	ComboboxOptions,
	Transition,
} from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { type Athlete } from '@prisma/client'
import { Fragment } from 'react'

type Props = {
	value: string
	options: Array<Athlete>
	renderDisplayValue: (item: Props['options'][0]) => string
	onSelection: (e: any) => any
	onTextChange: (e: any) => any
	clearTextInput?: () => any
	name?: string
}

export default function ComboBox(props: Props) {
	return (
		<div>
			<Combobox onChange={props.onSelection}>
				<div className="relative mt-1">
					<div className="relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300 sm:text-sm">
						<ComboboxInput
							placeholder="Runner Name"
							className="w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0"
							displayValue={props.renderDisplayValue}
							onChange={props.onTextChange}
							autoComplete="false"
							name={props.name}
						/>
						<ComboboxButton className="absolute inset-y-0 right-0 flex items-center pr-2">
							<ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
						</ComboboxButton>
					</div>
					<Transition
						as={Fragment}
						leave="transition ease-in duration-100"
						leaveFrom="opacity-100"
						leaveTo="opacity-0"
						afterLeave={() => null}
					>
						<ComboboxOptions
							anchor="bottom"
							className="mt-1 max-h-60 w-[var(--input-width)] overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm"
						>
							{props.options.length === 0 && props.value !== '' ? (
								<div
									key={'test'}
									className="relative cursor-default select-none px-4 py-2 text-gray-700"
								>
									Nothing found.
								</div>
							) : (
								props.options.map(item => (
									<ComboboxOption
										key={item.firstName + item.lastName}
										className={({ active }) =>
											`relative cursor-default select-none py-2 pl-10 pr-4 ${
												active ? 'bg-primary-foreground text-white' : 'text-gray-900'
											}`
										}
										value={item}
									>
										{({ selected, active }) => (
											<>
												<span
													className={`block truncate ${selected ? 'font-medium' : 'font-normal'}`}
												>
													{item.firstName} {item.lastName}
												</span>
												{selected ? (
													<span
														className={`absolute inset-y-0 left-0 flex items-center pl-3 ${
															active ? 'text-white' : 'text-primary-foreground'
														}`}
													>
														<CheckIcon className="h-5 w-5" aria-hidden="true" />
													</span>
												) : null}
											</>
										)}
									</ComboboxOption>
								))
							)}
						</ComboboxOptions>
					</Transition>
				</div>
			</Combobox>
		</div>
	)
}
